import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from './ui/select';
import usFlag from '../assets/flags/us.svg';
import gbFlag from '../assets/flags/gb.svg';
import caFlag from '../assets/flags/ca.svg';

/**
 * Component for switching between different languages/locales
 * Using flag icons for each country
 */
export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  // Available languages with flag icons
  const languages = [
    { value: 'en-US', label: 'English (US)', flag: usFlag },
    { value: 'en-GB', label: 'English (UK)', flag: gbFlag },
    { value: 'en-CA', label: 'English (Canada)', flag: caFlag },
    // To be added later:
    // { value: 'en-INT', label: 'English (International)', flag: intFlag },
  ];

  const handleLanguageChange = (value: string) => {
    i18n
      .changeLanguage(value)
      .then(() => {
        // Save to localStorage explicitly to ensure it persists
        localStorage.setItem('trackplicant-language', value);
      })
      .catch((error) => {
        console.error('Error changing language:', error);
      });
  };

  // Get current language flag
  const currentLanguage = languages.find(lang => lang.value === i18n.language) || languages[0];

  return (
    <div>
      <Select value={i18n.language} onValueChange={handleLanguageChange}>
        <SelectTrigger className="w-auto h-auto min-w-0 p-0 border-0 bg-transparent hover:bg-gray-100 transition-colors">
          <img 
            src={currentLanguage.flag} 
            alt={currentLanguage.label} 
            className="w-5 h-auto" 
            title={currentLanguage.label}
          />
        </SelectTrigger>
        <SelectContent>
          {languages.map((lang) => (
            <SelectItem key={lang.value} value={lang.value}>
              <div className="flex items-center gap-2">
                <img src={lang.flag} alt={lang.label} className="w-5 h-auto" />
                <span>{lang.label}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
